/**
 * This function is a TypeScript helper. Object.keys turns the keys into a Array<string>, which means every access with a key on that object, will show an error. This helper function turns the keys into a Array<keyof T> which means every access with a key on that object, will show the correct type.
 * @param {Object} obj any Record like Object
 * @returns {Array<keyof T>} Array of keys of the object
 */
export function objectKeys<T extends object>(obj: T): Array<keyof T> {
    return Object.keys(obj) as Array<keyof T>;
}
